import React, { useState, useEffect } from "react";
import { Form, Card, Button, Modal, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useGlobalState } from "../../../../services/hostelConst";
import {
  addLibraryBook,
  updateLibraryBook,
  getLibraryAuthors,
  getLibraryCategories,
  getLibraryPublications,
} from "../libraryServices/libraryManagement";
import {
  callToast,
  showErrorMessages,
} from "../../../../services/utilityFunctions";

const AddLibraryBookForm = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const libraryId = modalState.libraryId || (masterData && masterData._LIBRARY);
  console.log(
    "Library book modal state data:",
    masterData,
    "Library ID:",
    libraryId
  );

  const [isLoading, setIsLoading] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    totalStock: "",
    authorId: "",
    categoryId: "",
    publicationId: "",
    libraryId: libraryId || "",
    id: null,
  });
  const [errors, setErrors] = useState({});
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "success",
  });

  const [authorOptions, setAuthorOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [publicationOptions, setPublicationOptions] = useState([]);

  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPublication, setSelectedPublication] = useState(null);

  const [loadingAuthors, setLoadingAuthors] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingPublications, setLoadingPublications] = useState(false);

  useEffect(() => {
    if (libraryId) {
      console.log("Fetching data for library ID:", libraryId);
      fetchAuthors();
      fetchCategories();
      fetchPublications();
    } else {
      console.warn("No library ID provided, cannot fetch dropdowns");
    }
  }, [libraryId]);

  useEffect(() => {
    if (masterData) {
      console.log("Loading book data for editing:", masterData);
      setFormData({
        name: masterData.NAME || masterData.name || "",
        description: masterData.DESCRIPTION || masterData.description || "",
        totalStock: masterData.STOCK || "",
        authorId: masterData._AUTHOR || masterData.authorId || "",
        categoryId: masterData._CATEGORY || masterData.categoryId || "",
        publicationId:
          masterData._PUBLICATION || masterData.publicationId || "",
        libraryId:
          masterData._LIBRARY || masterData.libraryId || libraryId || "",
        id: masterData._ID || masterData.id || null,
      });
    }
  }, [masterData, libraryId]);

  // Fetch authors from API
  const fetchAuthors = async () => {
    if (!libraryId) {
      console.warn("Cannot fetch authors: No library ID");
      return;
    }

    try {
      setLoadingAuthors(true);
      console.log("Fetching authors for library ID:", libraryId);

      const response = await getLibraryAuthors({
        libraryId: libraryId,
        pageNum: 1,
        pageSize: 100,
        status: "Y",
      });

      console.log("Authors response:", response);

      if (response.status === "success") {
        const authors = response.data.entityList || [];
        console.log("Authors received:", authors);

        const options = authors.map((author) => ({
          value: author._ID,
          label: `${author["FIRST NAME"] || ""} ${author["LAST NAME"] || ""}`,
        }));

        console.log("Author options created:", options);
        setAuthorOptions(options);

        // Set selected author if editing
        if (masterData && masterData._AUTHOR) {
          const currentAuthor = options.find(
            (option) => option.value === masterData._AUTHOR
          );
          setSelectedAuthor(currentAuthor || null);
        }
      } else {
        console.error("Failed to fetch authors:", response);
        const myButton = document.getElementById("myToastButton");
        callToast("error", "Error", "Failed to load authors", myButton);
      }
    } catch (error) {
      console.error("Error fetching authors:", error);
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "Failed to load authors", myButton);
    } finally {
      setLoadingAuthors(false);
    }
  };

  // Fetch categories from API
  const fetchCategories = async () => {
    if (!libraryId) {
      console.warn("Cannot fetch categories: No library ID");
      return;
    }

    try {
      setLoadingCategories(true);
      console.log("Fetching categories for library ID:", libraryId);

      const response = await getLibraryCategories({
        libraryId: libraryId,
        pageNum: 1,
        pageSize: 100,
        status: "Y",

      });

      console.log("Categories response:", response);

      if (response.status === "success") {
        const categories = response.data.entityList || [];
        console.log("Categories received:", categories);

        const options = categories.map((category) => ({
          value: category._ID,
          label: category.NAME || category.name || "",
        }));

        console.log("Category options created:", options);
        setCategoryOptions(options);

        // Set selected category if editing
        if (masterData && masterData._CATEGORY) {
          const currentCategory = options.find(
            (option) => option.value === masterData._CATEGORY
          );
          setSelectedCategory(currentCategory || null);
        }
      } else {
        console.error("Failed to fetch categories:", response);
        const myButton = document.getElementById("myToastButton");
        callToast("error", "Error", "Failed to load categories", myButton);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "Failed to load categories", myButton);
    } finally {
      setLoadingCategories(false);
    }
  };

  // Fetch publications from API
  const fetchPublications = async () => {
    if (!libraryId) {
      console.warn("Cannot fetch publications: No library ID");
      return;
    }

    try {
      setLoadingPublications(true);
      console.log("Fetching publications for library ID:", libraryId);

      const response = await getLibraryPublications({
        libraryId: libraryId,
        pageNum: 1,
        pageSize: 100,
        status: "Y",

      });

      console.log("Publications response:", response);

      if (response.status === "success") {
        const publications = response.data.entityList || [];
        console.log("Publications received:", publications);

        const options = publications.map((publication) => ({
          value: publication._ID,
          label: publication.NAME || publication.name || "",
        }));

        console.log("Publication options created:", options);
        setPublicationOptions(options);

        // Set selected publication if editing
        if (masterData && masterData._PUBLICATION) {
          const currentPublication = options.find(
            (option) => option.value === masterData._PUBLICATION
          );
          setSelectedPublication(currentPublication || null);
        }
      } else {
        console.error("Failed to fetch publications:", response);
        const myButton = document.getElementById("myToastButton");
        callToast("error", "Error", "Failed to load publications", myButton);
      }
    } catch (error) {
      console.error("Error fetching publications:", error);
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "Failed to load publications", myButton);
    } finally {
      setLoadingPublications(false);
    }
  };

  // Handle text input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle author selection
  const handleAuthorChange = (selectedOption) => {
    console.log("Author selected:", selectedOption);
    setSelectedAuthor(selectedOption);
    setFormData((prev) => ({
      ...prev,
      authorId: selectedOption ? selectedOption.value : "",
    }));
  };

  // Handle category selection
  const handleCategoryChange = (selectedOption) => {
    console.log("Category selected:", selectedOption);
    setSelectedCategory(selectedOption);
    setFormData((prev) => ({
      ...prev,
      categoryId: selectedOption ? selectedOption.value : "",
    }));
  };

  // Handle publication selection
  const handlePublicationChange = (selectedOption) => {
    console.log("Publication selected:", selectedOption);
    setSelectedPublication(selectedOption);
    setFormData((prev) => ({
      ...prev,
      publicationId: selectedOption ? selectedOption.value : "",
    }));
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Book Name is required";
    if (!formData.description?.trim())
      newErrors.description = "Description is required";
    if (!formData.totalStock) newErrors.totalStock = "Total Stock is required";
    if (!formData.authorId) newErrors.authorId = "Author is required";
    if (!formData.categoryId) newErrors.categoryId = "Category is required";
    if (!formData.publicationId)
      newErrors.publicationId = "Publication is required";
    if (!formData.libraryId) newErrors.libraryId = "Library ID is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    handleConfirmedSubmit();
  };

  // Process form submission after validation
  const handleConfirmedSubmit = async () => {
    setIsLoading(true);

    try {
      console.log("Submitting form data:", formData);

      const response = formData.id
        ? await updateLibraryBook({
            ...formData,
            id: formData.id,
          })
        : await addLibraryBook(formData);

      console.log("API response:", response);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Book ${formData.id ? "updated" : "added"} successfully!`,
          myButton
        );

        if (typeof refresh === "function") {
          await refresh({ columnRefresh: false, isLoading: false });
        }

        setTimeout(() => {
          closeModal();
        }, 2000);
      } else if (response.status === "fail") {
        showErrorMessages({ data: response, navigate });
        const myButton = document.getElementById("myToastButton");
        callToast(
          "error",
          "Error",
          response.message ||
            `Failed to ${formData.id ? "update" : "add"} book`,
          myButton
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showErrorMessages({
        data: {
          message: `Failed to ${formData.id ? "update" : "add"} book`,
          errors: error.message,
        },
        navigate,
      });
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "An unexpected error occurred", myButton);
    } finally {
      setIsLoading(false);
    }
  };

  // Custom styles for Select components
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#80bdff" : provided.borderColor,
      boxShadow: state.isFocused
        ? "0 0 0 0.25rem rgba(0, 123, 255, 0.25)"
        : provided.boxShadow,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : provided.borderColor,
      },
    }),
  };

  return (
    <>
      <Card.Body className="px-4 py-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Book Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter book name"
              isInvalid={!!errors.name}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter book description"
              rows={3}
              isInvalid={!!errors.description}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Author</Form.Label>
                <Select
                  value={selectedAuthor}
                  onChange={handleAuthorChange}
                  options={authorOptions}
                  isLoading={loadingAuthors}
                  placeholder="Select Author"
                  isClearable
                  isSearchable
                  className={errors.authorId ? "is-invalid" : ""}
                  styles={customSelectStyles}
                  noOptionsMessage={() =>
                    loadingAuthors
                      ? "Loading authors..."
                      : authorOptions.length === 0
                      ? "No authors available. Please add authors first."
                      : "No matching authors"
                  }
                />
                {errors.authorId && (
                  <div className="invalid-feedback d-block">
                    {errors.authorId}
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Category</Form.Label>
                <Select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  options={categoryOptions}
                  isLoading={loadingCategories}
                  placeholder="Select Category"
                  isClearable
                  isSearchable
                  className={errors.categoryId ? "is-invalid" : ""}
                  styles={customSelectStyles}
                  noOptionsMessage={() =>
                    loadingCategories
                      ? "Loading categories..."
                      : categoryOptions.length === 0
                      ? "No categories available. Please add categories first."
                      : "No matching categories"
                  }
                />
                {errors.categoryId && (
                  <div className="invalid-feedback d-block">
                    {errors.categoryId}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Publication</Form.Label>
                <Select
                  value={selectedPublication}
                  onChange={handlePublicationChange}
                  options={publicationOptions}
                  isLoading={loadingPublications}
                  placeholder="Select Publication"
                  isClearable
                  isSearchable
                  className={errors.publicationId ? "is-invalid" : ""}
                  styles={customSelectStyles}
                  noOptionsMessage={() =>
                    loadingPublications
                      ? "Loading publications..."
                      : publicationOptions.length === 0
                      ? "No publications available. Please add publications first."
                      : "No matching publications"
                  }
                />
                {errors.publicationId && (
                  <div className="invalid-feedback d-block">
                    {errors.publicationId}
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Total Stock</Form.Label>
                <Form.Control
                  type="number"
                  name="totalStock"
                  value={formData.totalStock}
                  onChange={handleInputChange}
                  placeholder="Enter total stock"
                  isInvalid={!!errors.totalStock}
                  className="shadow-sm"
                  min="0"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.totalStock}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" onClick={closeModal} className="px-3">
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading
                ? formData.id
                  ? "Updating..."
                  : "Adding..."
                : formData.id
                ? "Update Book"
                : "Add Book"}
            </Button>
          </div>
        </Form>
      </Card.Body>

      <Modal
        show={showResponseModal}
        onHide={() => setShowResponseModal(false)}
        centered
        className={`response-modal ${modalConfig.type}`}
      >
        <Modal.Body className="text-center py-4">
          <div className={`response-icon ${modalConfig.type}`}>
            {modalConfig.type === "success" ? "✓" : "✕"}
          </div>
          <h5 className="mt-3">{modalConfig.title}</h5>
          <p className="mb-0">{modalConfig.message}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddLibraryBookForm;
